import {
  expensesAllReportsRouteProps,
  expensesOutOfPocketReportsAllRouteProps,
  expensesOutOfPocketReportsRouteProps,
  expensesOutOfPocketReportsYoursRouteProps,
  managerReviewReimbursementsRouteProps
} from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import OutOfPocketReportsAllReducer, {
  Actions as ExpenseReportsFullPaginatedDataActions,
  ExpenseReportsFullPaginatedDataState,
  initialState as initialExpenseReportsFullPaginatedDataState,
} from 'src/redux/outOfPocketReportsAllFullPaginatedData.reducer'

export type ApproverExpenseReportsState = {
  expenseReportsFullPaginatedData: ExpenseReportsFullPaginatedDataState
}

export const initialState: ApproverExpenseReportsState = {
  expenseReportsFullPaginatedData: initialExpenseReportsFullPaginatedDataState,
}

export type Actions = ExpenseReportsFullPaginatedDataActions

const CoreApproverExpenseReportsReducer = (
  state = initialState,
  action: Actions,
): ApproverExpenseReportsState => ({
  expenseReportsFullPaginatedData: OutOfPocketReportsAllReducer(
    state.expenseReportsFullPaginatedData,
    action as ExpenseReportsFullPaginatedDataActions,
  ),
})

const ApproverExpenseReportsReducer = createBackgroundReducer(
  [
    expensesAllReportsRouteProps,
    expensesOutOfPocketReportsRouteProps,
    expensesOutOfPocketReportsAllRouteProps,
    expensesOutOfPocketReportsYoursRouteProps,
    managerReviewReimbursementsRouteProps,
  ],
  initialState,
  CoreApproverExpenseReportsReducer,
)

export default ApproverExpenseReportsReducer
